interface PathLocation {
    id: PATHS;
    path: string;
    location: string;
};

export enum PATHS {
    ROOT = 'root',
    LOGIN = 'login',
    FORGOT = 'forgot',
    CHANGE = 'change',
    NOT_FOUND = '404',
    CLIENTS = 'clients',
};

export enum PROCESS_SERVICE_STATES {
    waiting = 'waiting',
    inProgress = 'in_progress',
    done = 'done'
};

export enum REQUEST_STATUSES {
    error = 1,
    success = 0
};

export enum ERRORS {
    malformedRequest = 'malformed_request'
};

export enum LOCAL_STORAGE_KEYS {
    token = 'token',
};

export enum Cookies {
    TOKEN = 'token'
}

/**
 * Am decis sa declar toate pathurile copiilor fiecarei rute, pentru a putea accesa in mod direct fara alte verificari
 * Astfel, daca am nevoie de un path, pot sa il accesez direct din PATH_LOCATIONS.children[PATHS.LOGIN].path
 */
type RootPath = PATHS.LOGIN | PATHS.CHANGE | PATHS.FORGOT | PATHS.NOT_FOUND | PATHS.CLIENTS;

type PathLocationChildren = {
    /* [K in (RootPath | OtherPath)]: PathLocation | PathLocationWithChildren; */
    [K in RootPath]: PathLocation | PathLocationWithChildren;
};

interface PathLocationWithChildren extends PathLocation {
    children: PathLocationChildren;
}

export const PATH_LOCATIONS: PathLocationWithChildren = {
    id: PATHS.ROOT,
    path: '/',
    location: '/',
    children: {
        [PATHS.LOGIN]: {
            id: PATHS.LOGIN,
            path: `/${PATHS.LOGIN}`,
            location: `/${PATHS.LOGIN}`,
        },
        [PATHS.FORGOT]: {
            id: PATHS.FORGOT,
            path: `/${PATHS.FORGOT}`,
            location: `/${PATHS.FORGOT}`,
        },
        [PATHS.CHANGE]: {
            id: PATHS.CHANGE,
            path: `/${PATHS.CHANGE}`,
            location: `/${PATHS.CHANGE}`,
        },
        [PATHS.NOT_FOUND]: {
            id: PATHS.NOT_FOUND,
            path: `/${PATHS.NOT_FOUND}`,
            location: `/${PATHS.NOT_FOUND}`,
        },
        [PATHS.CLIENTS]: {
            id: PATHS.CLIENTS,
            path: `/${PATHS.CLIENTS}`,
            location: `/${PATHS.CLIENTS}`,
        }
    }
};

export const LOCALIZATION_PATH = './localization';